/**
 * Qué módulos tiene contratados el usuario, para esconder lo que no compró.
 *
 * El backend manda la lista efectiva en `user.modulos` (ver `licencias.modulos_efectivos`).
 * Aquí sólo se consulta: la decisión de qué incluye cada plan es del backend, porque **esto
 * esconde, no protege** — quien quiera entrar con `curl` choca contra `RespetaModulos`.
 */

/**
 * `true` si el usuario puede ver ese módulo.
 *
 * Cuando `user.modulos` no viene --una sesión guardada antes de que el campo existiera-- no se
 * esconde nada: un menú vacío por un dato ausente es peor que un menú completo, y el backend
 * sigue negando lo que no se contrató.
 */
export function tieneModulo(user, clave) {
  if (!user) return false
  if (!Array.isArray(user.modulos)) return true
  return user.modulos.includes(clave)
}
